export default {
    mutateExternalCommonProperties ({ commit }, payload) {
        commit('mutateExternalCommonProperties', payload)
    },
    mutateExternalFormLoad ({ commit }, payload) {
        commit('mutateExternalFormLoad', payload)
    },
    mutateCommonProfile ({ commit }, payload) {
        commit('mutateCommonProfile', payload)
    },
    mutatePatientExternalDropdown ({ commit }, payload) {
        commit('mutatePatientExternalDropdown', payload)
    },
    mutateGrantExternalDropdown ({ commit }, payload) {
        commit('mutateGrantExternalDropdown', payload)
    },
    mutateStallParticipantExternalDropdown ({ commit }, payload) {
        commit('mutateStallParticipantExternalDropdown', payload)
    },
    localizeExternalDropdown ({ commit }, payload) {
        commit('localizeExternalDropdown', payload)
    },
    localizeTrainingExternalDropdown ({ commit }, payload) {
        commit('localizeTrainingExternalDropdown', payload)
    },
    localizePatientExternalDropdown ({ commit }, payload) {
        commit('localizePatientExternalDropdown', payload)
    },
    localizeStallParticipantExternalDropdown ({ commit }, payload) {
        commit('localizeStallParticipantExternalDropdown', payload)
    }
}
